"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoFocusInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var AutoFocusInput = function AutoFocusInput(_ref) {
  var autoFocus = _ref.autoFocus,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["autoFocus", "value", "defaultValue"]);
  var inputElement = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    // setTimeout is needed for the focus to trigger
    setTimeout(function () {
      if (autoFocus && inputElement.current) {
        inputElement.current.focus();
      }
    }, 0);
  }, [autoFocus]); // TODO: refactor readOnly input mecanism to get rid of defaultValue, and use value instead

  var controlledValue = {};

  if (props.readOnly && typeof defaultValue !== 'undefined') {
    controlledValue.defaultValue = defaultValue;
  } else {
    controlledValue.value = typeof value === 'undefined' ? '' : value;
  }

  return __jsx("input", (0, _extends2["default"])({}, controlledValue, props, {
    ref: inputElement
  }));
};

exports.AutoFocusInput = AutoFocusInput;